"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.email.contacts': 'Contacts',
    'whatsapp.email.noContacts': 'No email contacts found.',
    'whatsapp.email.loadFailed': 'Failed to load email contacts.',
    'whatsapp.email.stats.contacts': 'Contacts',
    'whatsapp.email.stats.total': 'Total',
    'whatsapp.email.trackLogs': 'Track Logs',
    'whatsapp.email.noLogs': 'No tracked logs yet.',
};
